import * as types from '../actiontypes';
import {serviceURL} from '../../util/uiconstants';
import Env from '../../util/env';

export const deleteDocumentToGLAccount = (engagementId, trialBalanceId, gLAccountId, documentId) => {
	let url = `${Env.getBaseURL(
		serviceURL,
		engagementId
	)}trialbalances/${trialBalanceId}/glaccounts/${gLAccountId}/documents/${documentId}`;
	return {
		type: types.DELETE_GLACCOUNT_DOCUMENT,
		meta: {
			api: {
				url: url,
				method: 'DELETE'
			}
		}
	};
};

export const addDocumentToGLAccount = (engagementId, trialBalanceId, gLAccountId, documentId) => {
	let url = `${Env.getServerUrl()}engagements/${engagementId}/trialbalances/${trialBalanceId}/glaccounts/${gLAccountId}/documents`;
	return {
		type: types.ADD_GLACCOUNT_DOCUMENT,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: {documentId: documentId}
			}
		}
	};
};
